/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import AddressActions from '@Actions/addressActions';
import './style.scss';
import NewAddressForm from '@Components/Common/FormUtils/NewAddressForm';
import { Drawer } from 'antd';
import UpdateAddressForm from '@Components/Common/FormUtils/UpdateAddressForm';

/**
 *
 */
class AddressSelector extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   *
   */
  static getDerivedStateFromProps(props, state) {
    const { getAddresses, entityType, entityId } = props;
    if ((props.entityId && props.entityType && !state.entityId && !state.entityType) ||
        (state.entityId && state.entityType && ((props.entityType !== state.entityType) || (props.entityId !== state.entityId)))) {
      getAddresses(1, entityId, entityType);
      return {
        ...state,
        entityId,
        entityType,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      addressType, tenantAddresses, sellerAddresses, selectedAddressId, onAddressChange, user, seller, getAddresses, onAddressUpdate,
      title, customer, entityId, entityType, getAddressesLoading, customerAddresses, documentType, tenantId,
    } = this.props;
    const { showNewAddressDrawer, showEditAddressDrawer, selectedAddressObject } = this.state;
    return (
      <Fragment>
        <Drawer
          open={showNewAddressDrawer}
          title="Add New Address"
          onClose={() => this.setState({ showNewAddressDrawer: false })}
          width="320px"
          destroyOnClose
        >
          <H3Text text="Add New Address" className="new-address__drawer-title" />
          <div className="update-po__new-vendor-wrapper">
            <NewAddressForm
              entityType={entityType}
              entityId={entityId}
              addressType={addressType}
              user={user}
              callback={
                () => {
                  this.setState({ showNewAddressDrawer: false });
                  if (entityType === 'SELLER') {
                    getAddresses(1, entityId, 'SELLER');
                  } else if (entityType === 'CUSTOMER') {
                    getAddresses(1, entityId, 'CUSTOMER');
                  } else if (entityType === 'TENANT') {
                    getAddresses(1, entityId, 'TENANT');
                  } else {
                    getAddresses(1, user?.tenant_info?.tenant_id, 'TENANT');
                  }
                }
              }
              customer={customer}
              seller={seller}
              tenantId={tenantId}
            />
          </div>
        </Drawer>
        <Drawer
          open={showEditAddressDrawer}
          title="Update Existing Address"
          onClose={() => this.setState({ showEditAddressDrawer: false })}
          width="320px"
          destroyOnClose
        >
          <H3Text text="Update Existing Address" className="new-address__drawer-title" />
          <div className="update-po__new-vendor-wrapper">
            <UpdateAddressForm
              entityType={entityType}
              entityId={entityId}
              addressType={addressType}
              user={user}
              addressObject={selectedAddressObject}
              callback={
                () => {
                  this.setState({ showEditAddressDrawer: false, selectedAddressObject: null });
                  if (entityType === 'SELLER') {
                    getAddresses(1, entityId, 'SELLER');
                  } else if (entityType === 'CUSTOMER') {
                    getAddresses(1, entityId, 'CUSTOMER');
                  } else if (entityType === 'TENANT') {
                    getAddresses(1, entityId, 'TENANT');
                  } else {
                    getAddresses(1, selectedAddressObject?.tenant_id || user?.tenant_info?.tenant_id, 'TENANT');
                  }
                  if (onAddressUpdate) {
                    onAddressUpdate();
                  }
                }
              }
              customer={customer}
              seller={seller}
              documentType={documentType}
              tenantId={tenantId}
            />
          </div>
        </Drawer>
        {!(getAddressesLoading)
          ? (
            <div className="address-selector__wrapper">
              <div className="address-selector__title-wrapper">
                <H3Text text={title ? `Update ${title}` : `Update ${addressType === 'TENANT' ? ' Delivery' : ' Vendor'} Address`} className="address-selector__title-text" />
                <H3Text text="+ New Address" className="address-selector__title-new-address" onClick={() => this.setState({ showNewAddressDrawer: true })} />
              </div>
              {entityType === 'SELLER' && (
                <div className="address__wrapper">
                  {
                sellerAddresses?.addresses?.map((item) => (
                  <div
                    key={item?.address_id}
                    className={`address__item ${selectedAddressId === item?.address_id ? 'address__item-selected' : ''}`}
                  >
                    <H3Text text={item?.address1} className="address__item-l1" />
                    <H3Text text={`${item?.city }, ${item?.state}, ${item?.postal_code}, ${item?.country}`} className="address__item-l2" />
                    <div className="address__item-actions">
                      <H3Text text={title ? `Select ${title}` : 'Select Address'} className="address__item-action" onClick={() => onAddressChange(item)} />
                      <H3Text text="Edit" className="address__item-edit" onClick={() => this.setState({ showEditAddressDrawer: true, selectedAddressObject: item })} />
                    </div>
                  </div>
                ))
                  }
                </div>
              )}

              {entityType === 'CUSTOMER' && (
                <div className="address__wrapper">
                  {
                  customerAddresses?.addresses?.map((item) => (
                    <div
                      key={item?.address_id}
                      className={`address__item ${selectedAddressId === item?.address_id ? 'address__item-selected' : ''}`}
                    >
                      <H3Text text={item?.address1} className="address__item-l1" />
                      <H3Text text={`${item?.city }, ${item?.state} ${item?.postal_code}`} className="address__item-l2" />
                      <div className="address__item-actions">
                        <H3Text text={title ? `Select ${title}` : 'Select Address'} className="address__item-action" onClick={() => onAddressChange(item)} />
                        <H3Text text="Edit" className="address__item-edit" onClick={() => this.setState({ showEditAddressDrawer: true, selectedAddressObject: item })} />
                      </div>
                    </div>
                  ))
                  }
                </div>
              )}
              {entityType === 'TENANT'
                && (
                  <div className="address__wrapper">
                    {
                tenantAddresses?.addresses?.map((item) => (
                  <div
                    key={item?.address_id}
                    className={`address__item ${selectedAddressId === item?.address_id ? 'address__item-selected' : ''}`}
                  >
                    <H3Text text={item?.address1} className="address__item-l1" />
                    <H3Text text={`${item?.city}, ${item?.state} ${item?.postal_code}`} className="address__item-l2" />
                    <div className="address__item-actions">
                      <H3Text text={title ? `Select ${title}` : 'Select Address'} className="address__item-action" onClick={() => onAddressChange(item)} />
                      <H3Text text="Edit" className="address__item-edit" onClick={() => this.setState({ showEditAddressDrawer: true, selectedAddressObject: item })} />
                    </div>
                  </div>
                ))
                    }
                  </div>
                )}

            </div>
          )
          : (
            <div className="">
              {[1, 2].map((item) => (
                <div
                  key={item}
                  className="address-selector-loading"
                  style={{ margin: '5px 0px' }}
                >
                  <div className="loadingBlock address-selector-city-loader" style={{ height: '20px', margin: '.6rem', width: '95%' }} />
                  <div className="loadingBlock" style={{ height: '20px', margin: '.6rem', width: '95%' }} />
                  <div className="loadingBlock" style={{ height: '10px', margin: '.6rem', width: '95%' }} />
                  <div
                    className=" ant-row "
                    style={{ margin: '.6rem' }}
                  >
                    <div className="loadingBlock ant-col-md-4" style={{ height: '15px' }} />
                    <div className="loadingBlock ant-col-md-4" style={{ height: '15px', marginLeft: '1rem' }} />
                  </div>
                </div>
              ))}
            </div>
          )}
      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param AddressReducer
 * @return {{sellerAddresses: *, user, tenantAddresses: *}}
 */
const mapStateToProps = ({ UserReducers, AddressReducer }) => ({
  user: UserReducers.user,
  sellerAddresses: AddressReducer.sellerAddresses,
  tenantAddresses: AddressReducer.tenantAddresses,
  customerAddresses: AddressReducer.customerAddresses,
  getAddressesLoading: AddressReducer.getAddressesLoading,
});

/**
 * @return {{}}
 * @param dispatch
 */
const mapDispatchToProps = (dispatch) => ({
  getAddresses: (page, entityId, entityType, addressId) => dispatch(AddressActions.getAddresses(page, entityId, entityType, addressId)),
});

AddressSelector.propTypes = {
  addresses: PropTypes.any,
  tenantAddresses: PropTypes.any,
  sellerAddresses: PropTypes.any,
  customerAddresses: PropTypes.any,
  addressType: PropTypes.string,
  selectedAddressId: PropTypes.any,
  onAddressChange: PropTypes.func,
  onAddressUpdate: PropTypes.func,
  user: PropTypes.any,
  seller: PropTypes.any,
  customer: PropTypes.any,
  getAddresses: PropTypes.func,
  getAddressesLoading: PropTypes.bool,
  title: PropTypes.any,
  entityType: PropTypes.any,
  entityId: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddressSelector));
